interface SparklineProps {
  data: { date: string; total: number }[];
  height?: number;
  showAxis?: boolean;
}

export function Sparkline({ data, height = 80, showAxis = false }: SparklineProps) {
  if (!data.length) {
    return (
      <div
        className="flex items-center justify-center text-xs text-ink-400 dark:text-ink-500"
        style={{ height }}
      >
        No data yet
      </div>
    );
  }
  const width = 800;
  const padX = showAxis ? 24 : 4;
  const padY = 6;
  const max = Math.max(1, ...data.map((d) => d.total));
  const stepX = (width - padX * 2) / Math.max(1, data.length - 1);
  const points = data.map((d, i) => {
    const x = padX + i * stepX;
    const y = padY + (1 - d.total / max) * (height - padY * 2);
    return `${x},${y}`;
  });
  const path = `M${points.join(' L')}`;
  const area = `${path} L${padX + (data.length - 1) * stepX},${height - padY} L${padX},${height - padY} Z`;
  return (
    <svg
      role="img"
      aria-label="Click activity over time"
      viewBox={`0 0 ${width} ${height}`}
      preserveAspectRatio="none"
      className="w-full"
      style={{ height }}
    >
      <path d={area} className="chart-area" />
      <path d={path} className="chart-line" />
      {showAxis && (
        <g className="text-[10px] fill-ink-400 dark:fill-ink-500" style={{ fontSize: 10 }}>
          <text x={padX} y={height - 1}>
            {data[0]?.date}
          </text>
          <text x={width - padX} y={height - 1} textAnchor="end">
            {data[data.length - 1]?.date}
          </text>
        </g>
      )}
    </svg>
  );
}
